module.exports = __webpack_public_path__ + "b95e1aa6f7bcb7440567918ca289f54a.pdf";